// useIsMobile — simple resize-listener hook for phone-width detection.
//
// Deliberately a NEW, separate hook rather than reusing VastuLayout.js's own
// inline `isMobile` state: that one checks < 992px to decide whether the
// *global app sidebar* should collapse (tablet/small-laptop cutoff). This
// hook is for phone-specific layout switches (e.g. Configure's editor
// screen going from 3-column desktop chrome to a bottom-sheet mobile
// layout) and needs its own, narrower breakpoint — 768px, the standard
// phone/tablet line — so a tablet in portrait still gets the desktop layout
// while a phone gets the mobile one.
import { useState, useEffect } from 'react';

export default function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth < breakpoint : false
  );

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < breakpoint);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, [breakpoint]);

  return isMobile;
}
